<template>
  <ValidationObserver>

    <div v-bind:id="'lang-' + index">
      <v-card color="grey lighten-5">
        <v-card-text>
          <v-form>
            <v-layout row wrap>

              <v-flex xs12 sm6 md6 lg6 xl6 pb-0>
                <ValidationProvider name="langue" rules="max:32">
                  <v-text-field
                    slot-scope="{
                                errors,
                                valid
                                }"
                    :error-messages="errors"
                    :success="valid"
                    label="Langue:"
                    v-model="item.title"
                    v-on:blur="$emit('update-item', item.id, item)"
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-flex>

              <v-flex xs12 sm6 md6 lg6 xl6 pb-0>
                <ValidationProvider name="niveau de langue" rules="numeric">
                  <v-select
                    slot-scope="{
                                errors,
                                valid
                                }"
                    :error-messages="errors"
                    :success="valid"
                    label="Niveau:"
                    v-model="item.level"
                    :items="lang_level_options"
                    item-text="text"
                    item-value="value"
                    v-on:blur="$emit('update-item', item.id, item)"
                  >
                  </v-select>
                </ValidationProvider>
              </v-flex>

              <v-flex xs12 pt-0>
                <ValidationProvider name="commentaires" rules="max:512">
                  <wysiwyg
                    slot-scope="{
                                errors,
                                valid
                                }"
                    :error-messages="errors"
                    :success="valid"
                    label="Commentaires:"
                    v-model="item.comments"
                    placeholder="Développer le contexte d'apprentissage de la langue (voyages, études, etc...)."
                    v-on:change="$emit('update-item', item.id, item)"
                  >
                  </wysiwyg>
                </ValidationProvider>
              </v-flex>

            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </ValidationObserver>
</template>



<script>

  import { mixin_basic } from './mixin_basic_vue.js';
  import { mixin_lang } from './mixin_lang.js';


  export default {
      mixins: [mixin_basic, mixin_lang],

  }

</script>
